import { type Device } from '~/types/Device';

import { useDeviceQuery } from './queries/useDeviceQuery';

const DEFAULT_DEVICE: Device = { architecture: 'unknown', browser: 'unknown', os: 'unknown' };

const useDevice = () => useDeviceQuery().data ?? DEFAULT_DEVICE;

export default useDevice;
